import { array, object, string } from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import Link from '../Link/Link';
import * as styles from './EditorialContent.css';
import RichText from '../RichText/RichText';

const cx = classNames.bind(styles);

class HeadingComponent extends PureComponent {
    static propTypes = {
        adobeAudience: string,
        callToActions: array,
        description: string,
        headline: string,
        headlineAboveClass: string,
        leadingText: string,
        primaryLink: object,
        seeDetailsLink: object,
        subHeadline: string,
    };

    static defaultProps = {
        adobeAudience: '',
        callToActions: [{}],
        description: '',
        headline: '',
        headlineAboveClass: '',
        leadingText: '',
        primaryLink: {},
        seeDetailsLink: {},
        subHeadline: '',
    };

    navigateurl = (event, link, targetWindow) => {
        event.preventDefault();
        return {
            url: link,
            openInNewTab: targetWindow,
        };
    };

    paintMainContent = () => {
        let mainContent = '';
        const { adobeAudience, seeDetailsLink } = this.props;
        /* istanbul ignore else */
        if (seeDetailsLink) {
            const mainLink = get(seeDetailsLink, 'link', {});
            let linkUrl = get(mainLink, 'url', '');
            const mainLinkText = get(seeDetailsLink, 'linkText', '');
            const openInNewTab = get(seeDetailsLink, 'openInNewTab', false);

            linkUrl = linkUrl && adobeAudience ? `${linkUrl}-_-${adobeAudience}` : linkUrl;

            /* istanbul ignore else */
            if (linkUrl || mainLinkText) {
                mainContent = (
                    <Link
                        href={linkUrl}
                        data-automation-id="description-link"
                        onClick={(event) => this.navigateurl(event, linkUrl, openInNewTab)}
                        className={cx('seeDetailsLink', 'editInfoLink')}
                    >
                        <RichText
                            richTextClass={cx('richLegal')}
                            automationId="description-link-richtext"
                            text={mainLinkText}
                        />
                    </Link>
                );
            }
        }

        return mainContent;
    };

    render() {
        const {
            adobeAudience,
            callToActions,
            description,
            headline,
            headlineAboveClass,
            leadingText,
            primaryLink,
            subHeadline,
        } = this.props;

        const firstCTALink = get(callToActions[0], 'link.url', '');
        const primaryLinkUrl = get(primaryLink, 'link.url', '');
        let href = primaryLinkUrl || firstCTALink;
        const seeDetailsElement = this.paintMainContent();

        href = href && adobeAudience ? href.concat(`-_-${adobeAudience}`) : href;

        const openInNewTab = get(primaryLink, 'openInNewTab', '');
        const textLeadingTitle = leadingText ? (
            <h2 data-automation-id="leadingtext" className={cx('subTitle')}>
                {/* istanbul ignore next */}
                <RichText richTextClass={cx('richBody')} text={leadingText} />
            </h2>
        ) : (
            ''
        );
        /* istanbul ignore next */
        const textTitle =
            href || headline ? (
                <h3 data-automation-id="main-title" className={cx('mainTitleHeading')}>
                    <Link
                        onClick={(event) => this.navigateurl(event, href, openInNewTab)}
                        href={href}
                        className={cx('mainTitle')}
                        data-automation-id="main-title-link"
                    >
                        <RichText richTextClass={cx('richHeading')} text={headline} />
                    </Link>
                </h3>
            ) : (
                ''
            ); /* eslint-disable-line react/no-danger */

        /* istanbul ignore next */
        const textSubTitle =
            description || subHeadline || seeDetailsElement ? (
                <h4 data-automation-id="description" className={cx('subTitle')}>
                    <RichText
                        richTextClass={cx('richBody')}
                        text={description || subHeadline || ''}
                    />
                    {/* eslint-enable react/no-danger */}
                    {seeDetailsElement}
                </h4>
            ) : (
                ''
            );
        return (
            <div className={cx('heading-component', headlineAboveClass)}>
                {textLeadingTitle}
                {textTitle}
                {textSubTitle}
            </div>
        );
    }
}

export default HeadingComponent;
